/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerContractPricingDto } from './BorrowerContractPricingDto';
import {
    BorrowerContractPricingDtoFromJSON,
    BorrowerContractPricingDtoFromJSONTyped,
    BorrowerContractPricingDtoToJSON,
    BorrowerContractPricingDtoToJSONTyped,
} from './BorrowerContractPricingDto';
import type { BorrowerContractGuaranteeDto } from './BorrowerContractGuaranteeDto';
import {
    BorrowerContractGuaranteeDtoFromJSON,
    BorrowerContractGuaranteeDtoFromJSONTyped,
    BorrowerContractGuaranteeDtoToJSON,
    BorrowerContractGuaranteeDtoToJSONTyped,
} from './BorrowerContractGuaranteeDto';

/**
 * Loan details within a borrower contract including guarantees and pricing
 * @export
 * @interface BorrowerContractLoanDetailDto
 */
export interface BorrowerContractLoanDetailDto {
    /**
     * Unique identifier of the loan
     * @type {string}
     * @memberof BorrowerContractLoanDetailDto
     */
    id: string;
    /**
     * Internal loan number
     * @type {number}
     * @memberof BorrowerContractLoanDetailDto
     */
    internalNumber: number;
    /**
     * Total loan amount
     * @type {number}
     * @memberof BorrowerContractLoanDetailDto
     */
    loanAmount: number;
    /**
     * Total duration of the loan in months
     * @type {number}
     * @memberof BorrowerContractLoanDetailDto
     */
    totalDuration: number;
    /**
     * Interest rate type label (e.g. Fixed, Variable)
     * @type {string}
     * @memberof BorrowerContractLoanDetailDto
     */
    interestRateType?: string | null;
    /**
     * Interest rate type code
     * @type {string}
     * @memberof BorrowerContractLoanDetailDto
     */
    interestRateTypeCode?: string | null;
    /**
     * Interest rate percentage
     * @type {number}
     * @memberof BorrowerContractLoanDetailDto
     */
    interestRatePercentage?: number;
    /**
     * Loan type label
     * @type {string}
     * @memberof BorrowerContractLoanDetailDto
     */
    loanType?: string | null;
    /**
     * Loan type code
     * @type {string}
     * @memberof BorrowerContractLoanDetailDto
     */
    loanTypeCode?: string | null;
    /**
     * Deferment period in months
     * @type {number}
     * @memberof BorrowerContractLoanDetailDto
     */
    defermentPeriod?: number;
    /**
     * Deferment type label
     * @type {string}
     * @memberof BorrowerContractLoanDetailDto
     */
    defermentType?: string | null;
    /**
     * Deferment type code
     * @type {string}
     * @memberof BorrowerContractLoanDetailDto
     */
    defermentTypeCode?: string | null;
    /**
     * Borrower quota percentage
     * @type {number}
     * @memberof BorrowerContractLoanDetailDto
     */
    quota?: number;
    /**
     * Deductible period in days
     * @type {number}
     * @memberof BorrowerContractLoanDetailDto
     */
    deductible?: number;
    /**
     * List of guarantees associated with the loan
     * @type {Array<BorrowerContractGuaranteeDto>}
     * @memberof BorrowerContractLoanDetailDto
     */
    guarantees?: Array<BorrowerContractGuaranteeDto>;
    /**
     * 
     * @type {BorrowerContractPricingDto}
     * @memberof BorrowerContractLoanDetailDto
     */
    pricing?: BorrowerContractPricingDto;
}

/**
 * Check if a given object implements the BorrowerContractLoanDetailDto interface.
 */
export function instanceOfBorrowerContractLoanDetailDto(value: object): value is BorrowerContractLoanDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('internalNumber' in value) || value['internalNumber'] === undefined) return false;
    if (!('loanAmount' in value) || value['loanAmount'] === undefined) return false;
    if (!('totalDuration' in value) || value['totalDuration'] === undefined) return false;
    return true;
}

export function BorrowerContractLoanDetailDtoFromJSON(json: any): BorrowerContractLoanDetailDto {
    return BorrowerContractLoanDetailDtoFromJSONTyped(json, false);
}

export function BorrowerContractLoanDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerContractLoanDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'internalNumber': json['internalNumber'],
        'loanAmount': json['loanAmount'],
        'totalDuration': json['totalDuration'],
        'interestRateType': json['interestRateType'] == null ? undefined : json['interestRateType'],
        'interestRateTypeCode': json['interestRateTypeCode'] == null ? undefined : json['interestRateTypeCode'],
        'interestRatePercentage': json['interestRatePercentage'] == null ? undefined : json['interestRatePercentage'],
        'loanType': json['loanType'] == null ? undefined : json['loanType'],
        'loanTypeCode': json['loanTypeCode'] == null ? undefined : json['loanTypeCode'],
        'defermentPeriod': json['defermentPeriod'] == null ? undefined : json['defermentPeriod'],
        'defermentType': json['defermentType'] == null ? undefined : json['defermentType'],
        'defermentTypeCode': json['defermentTypeCode'] == null ? undefined : json['defermentTypeCode'],
        'quota': json['quota'] == null ? undefined : json['quota'],
        'deductible': json['deductible'] == null ? undefined : json['deductible'],
        'guarantees': json['guarantees'] == null ? undefined : ((json['guarantees'] as Array<any>).map(BorrowerContractGuaranteeDtoFromJSON)),
        'pricing': json['pricing'] == null ? undefined : BorrowerContractPricingDtoFromJSON(json['pricing']),
    };
}

export function BorrowerContractLoanDetailDtoToJSON(json: any): BorrowerContractLoanDetailDto {
    return BorrowerContractLoanDetailDtoToJSONTyped(json, false);
}

export function BorrowerContractLoanDetailDtoToJSONTyped(value?: BorrowerContractLoanDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'internalNumber': value['internalNumber'],
        'loanAmount': value['loanAmount'],
        'totalDuration': value['totalDuration'],
        'interestRateType': value['interestRateType'],
        'interestRateTypeCode': value['interestRateTypeCode'],
        'interestRatePercentage': value['interestRatePercentage'],
        'loanType': value['loanType'],
        'loanTypeCode': value['loanTypeCode'],
        'defermentPeriod': value['defermentPeriod'],
        'defermentType': value['defermentType'],
        'defermentTypeCode': value['defermentTypeCode'],
        'quota': value['quota'],
        'deductible': value['deductible'],
        'guarantees': value['guarantees'] == null ? undefined : ((value['guarantees'] as Array<any>).map(BorrowerContractGuaranteeDtoToJSON)),
        'pricing': BorrowerContractPricingDtoToJSON(value['pricing']),
    };
}

